import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  Button,
  Spinner,
} from "reactstrap";
import { MdModeEdit, MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiClient from "../../api-client";
import { useDispatch } from "react-redux";
import Swal from 'sweetalert2';

function List() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [templates, setTemplates] = useState([]);
  const [showAlter, setShowAlter] = useState(false);
  const [alertLoader, setAlertLoader] = useState(false);
  const [templateId, setTemplateId] = useState(null);

  const [page, setPage] = useState(1);
  const [limit] = useState(10); 
  const [totalPages, setTotalPages] = useState(0); 
  const [totalRecords, setTotalRecords] = useState(0);
  const [loader, setLoader] = useState(false);


  const fetchTemplates = async () => {
    setLoader(true);
    try {
      const response = await ApiClient.get(`api/users/list-templates?page=${page}&limit=${limit}&status=unread`, "", true, dispatch);
      const { status, body } = response;
      if (status) {
        setTemplates(body.result);
        setTotalPages(body.totalPages);
        setTotalRecords(body.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
      toast.error("Error fetching templates", { autoClose: 3000 });
    } finally {
      setLoader(false);
    }
  };

  const openAlertDialog = (id) => {
    setTemplateId(id);
    setShowAlter(true);
  };

  const handleDelete = async () => {
    if (templateId) {
      try {
        setAlertLoader(true);
        const response = await ApiClient.delete(`api/users/delete-template/${templateId}`, {}, true, dispatch); // Pass templateId as part of the URL
        if (response.status) {
          toast.success(response.message, { autoClose: 3000 });
          fetchTemplates();
        } else {
          toast.error("Failed to delete template", { autoClose: 3000 });
        }
      } catch (error) {
        toast.error("Failed to delete template", { autoClose: 3000 });
      } finally {
        setAlertLoader(false);
        setShowAlter(false);
      }
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, [page]);

  const handleNextPage = () => {
    if (page < totalPages) setPage((prev) => prev + 1);
  };

  const handlePreviousPage = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const editDetails = (id) => {
    navigate(`/admin/template/edit?id=${id}`);
  };

  return (
    <>
      <div className="content">
      <div className="content-headline d-flex justify-content-between">
        <h4>Templates</h4>
      </div>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="9">
                    <h4>Template List</h4>
                  </Col>
                  <Col md="3">
                    <Button
                      color="primary"
                      className="common-button mt-0"
                      onClick={() => navigate("/admin/template/add")}
                    >
                      Create New Template
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {loader && (
                  <span className="table-loader">
                    <Spinner color="primary">Loading...</Spinner>
                  </span>
                )}
                {!loader && (
                  <>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Sr. No</th>
                          <th>Title</th>
                          <th>Notification Type</th>
                          <th>Notification Sub-Type</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {templates.map((template, index) => (
                          <tr key={template._id}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            <td>{template.title}</td>
                            <td>{template.notificationType}</td>
                            <td>{template.notificationSubType}</td>
                            <td className="text-center">
                              <span
                                className="action-icon action-icon-yellow"
                                onClick={() => editDetails(template._id)}
                              >
                                <MdModeEdit />
                              </span>
                              <span
                                className="action-icon action-icon-red"
                                onClick={() => openAlertDialog(template._id)}
                              >
                                <MdDelete />
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="pagination d-flex justify-content-center align-items-center">
                      <Button
                        onClick={handlePreviousPage}
                        disabled={page === 1}
                        className="common-button"
                      >
                        Previous
                      </Button>
                      <span className="mx-3">
                        Page {page} of {totalPages}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={page === totalPages}
                        className="common-button"
                      >
                        Next
                      </Button>
                      <span className="ms-3">
                        <strong>Total records:</strong> {totalRecords}
                      </span>
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showAlter && (
        <Swal
          danger
          showCancel
          confirmBtnText={
            alertLoader ? (
              <span>
                Confirm <Spinner size="sm" />
              </span>
            ) : (
              "Confirm"
            )
          }
          confirmBtnBsStyle="danger"
          title="Are you sure?"
          onConfirm={handleDelete}
          onCancel={() => setShowAlter(false)}
          focusCancelBtn
        >
          You want to delete this template?
        </Swal>
      )}
    </>
  );
}

export default List;
